module.exports = __webpack_public_path__ + "img/authorization-identityless.svg";